import { buildTodayFilterDocument } from '@griply/utils';
import Typography from '@mui/material/Typography';
import { useTasksByFilterDocument } from 'features/tasks';
import React, { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

import * as Styled from './today-count.style';

export const LoadingTodayCount: React.FC = () => <Styled.Container $loading />;

export const TodayCount: React.FC = () => {
  const today = useToday();
  const user = useUser();

  const filterDocument = useMemo(
    () => buildTodayFilterDocument(today, user?.settings),
    [today, user?.settings],
  );

  const tasks = useTasksByFilterDocument(filterDocument, {
    includeTaskWithAction: true,
    excludeHiddenTodoHabits: true,
  });

  return !!tasks.length ? (
    <Styled.Container>
      <Typography variant="overline" component="span">
        {tasks.length}
      </Typography>
    </Styled.Container>
  ) : null;
};
